import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import React from "react";

const CampaignsHeader: React.FC<{ search: string; onSearch: (v: string) => void }> = ({ search, onSearch }) => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    justifyContent="space-between"
    alignItems={{ xs: "flex-start", sm: "center" }}
    sx={{ mb: 2 }}
    spacing={2}
  >
    <Typography variant="h5">Email Campaigns</Typography>
    <TextField
      placeholder="Search for a campaign"
      value={search}
      onChange={(e) => onSearch(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        inputProps: { "aria-label": "Search campaigns" },
      }}
      sx={{ minWidth: 320 }}
    />
  </Stack>
);

export default CampaignsHeader;